import { Component } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'dashonic';

  constructor() {
    // DEV environment: a distinct favicon + tab title so a dev tab can never be mistaken for production
    if (environment.isDevEnv) {
      document.title = 'Nirlat DEV';
      document
        .querySelector<HTMLLinkElement>('link[rel="icon"]')
        ?.setAttribute('href', 'assets/images/favicon-dev.png');
    }
  }
}
